import { defaultParsedImages } from "../../../Generic/custom_api/drupal_node_conversion";
export const emptyJumbo = {
    supertitle: '',
    title: '',
    subtitle: '',
    contents: '',
    imageStyles: defaultParsedImages,
    imageUrlSmall: '',
    imageUrl: '',
    imageUrlFallback: '',
    imageUrlLarge: '',
    imageAlt: '',
    size: 'large'
};
